import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(theme => ({
  paper: {
    borderRadius: 8,
    overflow: 'hidden'
  },
  backdrop: {
    backgroundColor: 'rgba(26, 26, 26, 0.55)',
    backdropFilter: 'blur(4px)'
  },
  closeButton: {
    position: 'absolute',
    top: 12,
    right: 12,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    transition: 'background-color 200ms',
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  },
  content: {
    padding: theme.spacing(4)
  },
  eyebrow: {
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(0.5)
  },
  title: {
    fontWeight: 700,
    marginBottom: theme.spacing(1)
  },
  titleClearsClose: {
    paddingRight: theme.spacing(4)
  },
  sideLayout: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'row',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column'
    }
  },
  /* Image sits in a padded card with the Skill Bites 8px radius, instead of
   * bleeding to the modal edges. */
  sideImageWrap: {
    padding: theme.spacing(3),
    paddingRight: 0,
    width: 340,
    flexShrink: 0,
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: theme.spacing(3)
    }
  },
  sideImage: {
    display: 'block',
    objectFit: 'cover',
    width: '100%',
    height: '100%',
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
      height: 200
    }
  },
  bannerImage: {
    display: 'block',
    width: '100%',
    height: 250,
    objectFit: 'cover'
  },
  intro: {
    marginBottom: theme.spacing(2)
  },
  toolRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
    textAlign: 'left',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: 'transparent',
    cursor: 'pointer',
    transition: 'background-color 200ms',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
    // Keyboard focus never relies on the UA default (PENG-2492 bar).
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2
    }
  },
  /* Brand-coloured tile, like the marketing site's tool cards. Colours come
   * from the `feature` semantic tokens (theme/palette) — the toolbar SVGs are
   * dark baked bitmaps, so those tiles stay bright for contrast. */
  toolTile: {
    width: 48,
    height: 48,
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  toolTileMcoach: {
    backgroundColor: theme.palette.feature.mcoach.tile
  },
  toolTileSkillBites: {
    backgroundColor: theme.palette.feature.skillBites.tile
  },
  toolTilePlaylists: {
    backgroundColor: theme.palette.feature.playlists.tile
  },
  featureRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2)
  },
  featureTile: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: theme.palette.feature.tint,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  rowTitle: {
    fontWeight: 700
  },
  rowBody: {
    lineHeight: 1.5
  },
  testimonial: {
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'flex-start',
    marginTop: theme.spacing(2.5),
    paddingTop: theme.spacing(2.5),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  // Initial-in-a-circle rather than a stock photo: the quote is real, the face
  // would not be, and a placeholder portrait reads as a person we never asked.
  testimonialAvatar: {
    width: 40,
    height: 40,
    flexShrink: 0,
    fontSize: '1rem',
    fontWeight: 700,
    backgroundColor: theme.palette.feature.tint,
    color: theme.palette.text.primary
  },
  testimonialQuote: {
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
    lineHeight: 1.5
  },
  testimonialName: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    marginTop: theme.spacing(0.5),
    display: 'block'
  },
  ctaRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2.5)
  },
  resourceCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8
  },
  inlineCta: {
    marginTop: theme.spacing(1)
  }
}))
